import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-cycle',
  templateUrl: 'cycle.component.html',
  imports: [RouterOutlet],
})
export class CycleComponent {}
